/**
 * GuestRoute Component
 * Redirects authenticated users to their role-based landing page.
 * The inverse of ProtectedRoute — only renders children for unauthenticated users.
 */

import { Navigate, Outlet } from 'react-router-dom';
import { hasAdminAccess } from '../../lib/roles';
import { useAuthStore } from '../../stores/auth.store';

export const GuestRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuthStore();

  // Wait for auth initialization before deciding
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-meta">Loading...</p>
        </div>
      </div>
    );
  }

  // Already authenticated — redirect to appropriate landing page
  if (isAuthenticated) {
    const redirectPath = hasAdminAccess(user?.role) ? '/dashboard' : '/home';
    return <Navigate to={redirectPath} replace />;
  }

  // Not authenticated — render child routes
  return <Outlet />;
};
